import React, { useState, useRef, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import get from 'lodash/get';
import { selectWsDetail } from 'store/Workspace/selectors';
import { showUpdateModal } from 'Screens/Contextualization/Workspaces/actions/Actions';
import { Wrapper, InputTitle, IconWorkspace } from './styled';
import { LockIcon } from 'Screens/Contextualization/Workspaces/components/Table/LockUnlockWs/styled';

const Title = () => {
  const dispatch = useDispatch();
  const workspaceDetail = useSelector(selectWsDetail);
  const currentName = get(workspaceDetail, 'name', '');
  const currentNameRef = useRef(currentName);
  const [wsName, setWsName] = useState(workspaceDetail.name);
  const readOnly = get(workspaceDetail, 'readonly', false);

  const onClick = () => dispatch(showUpdateModal());

  useEffect(() => {
    setWsName(workspaceDetail.name);
  }, [workspaceDetail]);

  useEffect(() => {
    currentNameRef.current = currentName;
  }, [currentName]);

  return (
    <Wrapper onClick={ onClick }>
      <IconWorkspace />
        <InputTitle value={ wsName } />
      { readOnly && <LockIcon title="This Workspace is locked (read-only)" /> }
    </Wrapper>
  );
};

export default Title;
